class Decorator {
    static create() {
        return new Decorator();
    }

    checkbox(el) {
        el.checked = () => el.prop('checked');
        el.uncheck = () => el.prop('checked', false);

        return el;
    }

    createErrorEl({cls, message}) {
        return $('<div/>')
            .addClass(`error ${cls}`)
            .attr('role', 'alert')
            .attr('aria-live', 'assertive')
            .html(message);
    }

    errorAndEnterKeyPress(el) {
        el.addError = message => {
            var describedById = `${el.attr('id')}-error`;

            el.attr('aria-invalid', true).attr('aria-errormessage', describedById);
            this.createErrorEl({cls: 'field-error', message}).attr('id', describedById).insertAfter(el);
            el.trigger('fieldError');
        };

        el.keypress(event => {
            if (event.key === 'Enter') {
                $(el).trigger('enterKeyPress');
            }
        });

        return el;
    }

    preventDefaultClick(el) {
        el.click(event => event.preventDefault());

        return el;
    }

    sectionError(el) {
        el.addError = message => {
            this.createErrorEl({cls: 'form-error', message}).appendTo(el.find('.error-wrapper'));
            el.trigger('formError');
        };

        return el;
    }

    spinnerButton(el) {
        var addSpinner = () => el.prepend($('<span class="btn-spinner"/>')),
            removeSpinner = () => el.find('.btn-spinner').remove();

        el.toggleSpinner = toggle => {
            el.attr('disabled', toggle);

            toggle ? addSpinner() : removeSpinner();
        };

        return el;
    }
}

export default Decorator;
